module.exports = fox._r("images/slides/slide_1_3.jpg", __webpack_public_path__ + "images/slides/slide_1_3.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/slide_1_3.jpg
// module id = 506
// module chunks = 2